import ApplicationController from './application_controller'
import EditableText from 'components/EditableText'
import { createRoot } from 'react-dom/client'

class EditableStringController extends ApplicationController {
  connect () {
    const content = $(this.element).text().trim()

    const root = createRoot(this.element)
    root.render(
      <EditableText text={content} type='string' />
    )
  }
}

export default EditableStringController
